import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDetail(detail) {
  if (detail == null) return "Login failed. Dobara try karein.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  return String(detail);
}

const inputCls =
  "w-full border-b border-line bg-transparent py-3 text-base text-cream placeholder:text-sage/50 outline-none transition-colors duration-300 focus:border-harvest";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("jamna_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-forest px-6 font-body text-cream">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md border border-line bg-moss p-8 sm:p-12"
        data-testid="admin-login-card"
      >
        <p className="font-display text-2xl font-bold tracking-tight">
          JAMNA <span className="italic text-harvest">ADMIN</span>
        </p>
        <p className="mt-2 text-xs uppercase tracking-[0.2em] text-sage">
          Website content manage karne ke liye login karein
        </p>

        <form onSubmit={onSubmit} className="mt-10 space-y-8">
          <div>
            <label htmlFor="admin-email" className="text-xs uppercase tracking-[0.2em] text-sage">
              Email
            </label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="aapka@email.com"
              className={inputCls}
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="text-xs uppercase tracking-[0.2em] text-sage">
              Password
            </label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className={inputCls}
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="border border-red-400/40 bg-red-400/10 px-4 py-3 text-sm text-red-300">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="group inline-flex w-full items-center justify-center gap-3 bg-harvest px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-forest transition-colors duration-300 hover:bg-harvestHover disabled:opacity-60"
          >
            {loading ? "Logging in…" : "Login"}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
        </form>

        <Link
          to="/"
          data-testid="back-to-site-link"
          className="mt-8 block text-center text-xs uppercase tracking-[0.15em] text-sage transition-colors duration-300 hover:text-harvest"
        >
          ← Back to Website
        </Link>
      </motion.div>
    </div>
  );
}
